import Keyboard from "components/common/Keyboard/Keyboard";
import KeyboardContainer from "components/common/Keyboard/Keyboard.container";
import React from "react";

interface IProps {
  onChange?(value: string): void;
  onEnterPressed?(): void;
}

const ConnectedKeyboard = ({ onChange, onEnterPressed }: IProps) => {
  const {
    isOpen,
    setIsOpen,
    inputName,
    keyboardRef
  } = KeyboardContainer.useContainer();

  return (
    <Keyboard
      keyboardRef={keyboardRef}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      inputName={inputName}
      onEnterPressed={onEnterPressed}
      onChange={onChange}
    />
  );
};

export default ConnectedKeyboard;



// WEBPACK FOOTER //
// ./src/components/common/Keyboard/ConnectedKeyboard.tsx